import type { Program } from 'models';
import type { EventContentObjectDataObject, TopicDataObject } from 'models/service';

import { CreateEventFormModal } from './components';
import { useCreateProgramEventPermissions } from './hooks';

type P = {
  isOpened: boolean;
  onCancel: () => void;
  onRequestReturn?: () => void;
  onSuccess: (eventData: EventContentObjectDataObject) => Promise<void> | void;
  preSelectedProgramTopic?: TopicDataObject;
  program?: Program;
};

export const CreateProgramEvent = ({ isOpened, preSelectedProgramTopic, ...rest }: P) => {
  const { createEventAllowedTypes } = useCreateProgramEventPermissions({
    program: rest.program,
  });

  // TODO: This is Hack. This is ruining accessibility
  if (!isOpened) {
    return null;
  }

  const initialData = preSelectedProgramTopic
    ? {
        programTopicId: preSelectedProgramTopic.id,
      }
    : undefined;

  return (
    <CreateEventFormModal
      eventTypes={createEventAllowedTypes}
      initialDefaultData={initialData}
      isOpened={isOpened}
      {...rest}
    />
  );
};
